import React, { useEffect, useState } from "react"

import { GetMarketplaceLoanPaymentOptionsResponse } from "@lib/clients/nelo-api-client"
import { sendGoogleAnalyticsEvent } from "@modules/common/utils/analytics"

import InstallmentOption from "./individual-installment"
import NeloBackgroundContainer from "./nelo-background-container"

interface InstallmentContainerProps {
  loanOptions: GetMarketplaceLoanPaymentOptionsResponse | null
  onOptionSelect: (uuid: string) => void
  preSelectedInstallment?: number
}

const InstallmentContainer: React.FC<InstallmentContainerProps> = ({ loanOptions, onOptionSelect, preSelectedInstallment }) => {
  const [selectedOption, setSelectedOption] = useState<string | null>(null)
  const [hasInitialized, setHasInitialized] = useState<boolean>(false)

  useEffect(() => {
    if (!hasInitialized && loanOptions?.paymentOptions && loanOptions.paymentOptions.length > 0) {
      let optionToSelect = null

      if (preSelectedInstallment) {
        optionToSelect = loanOptions.paymentOptions.find((option) => option.installments === preSelectedInstallment)
      }

      if (!optionToSelect) {
        optionToSelect = [...loanOptions.paymentOptions].sort((a, b) => b.installments - a.installments)[0]
      }

      if (optionToSelect) {
        setSelectedOption(optionToSelect.uuid)
        onOptionSelect(optionToSelect.uuid)
      }

      setHasInitialized(true)
    }
  }, [loanOptions, preSelectedInstallment, onOptionSelect])

  if (!loanOptions || !loanOptions.paymentOptions) {
    return <div className="text-gray-600">Cargando ...</div>
  }

  const handleOptionSelect = (uuid: string) => {
    setSelectedOption(uuid)
    onOptionSelect(uuid)
    sendGoogleAnalyticsEvent("INSTALLMENT_OPTION_SELECTED", {
      option: uuid,
    })
  }

  return (
    <NeloBackgroundContainer title="Elige tu plan de pagos">
      {loanOptions.paymentOptions.map((option) => (
        <InstallmentOption
          key={option.uuid}
          uuid={option.uuid}
          title={option.title}
          subtitle={option.subtitle}
          tabInstallmentLabel={option.tabInstallmentLabel}
          isSelected={selectedOption === option.uuid}
          onSelect={handleOptionSelect}
        />
      ))}
    </NeloBackgroundContainer>
  )
}

export default InstallmentContainer
